/**
 * @desc 获取树形结构
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LabelInfoTreeResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelInfo/tree`, {
      method: "GET",

      ...options,
    }),
  );
}
